import getHttpClient from '../../common/http-common';

export const postReactivateUsersInTenant = (tenantCode: string) =>
    getHttpClient().post('OktaWorkflows/ReactivateUsersInTenant', {
        tenantCode
    });
